export default {
    install(Vue) {
        if (this.installed) {
            return;
        }

        this.installed = true;

        const event = new Vue();
        const modal = {
            get event() {
                return event;
            },

            open(name, params) {
                event.$emit('toggle', name, true, params);
            },

            close(name, params) {
                event.$emit('toggle', name, false, params);
            },

            toggle(name, params) {
                event.$emit('toggle', name, undefined, params);
            },
        };

        Vue.prototype.$modal = modal;
        Vue.modal = modal;
    },
};
